module.exports = __webpack_public_path__ + "2bcb22616242fcdf06a9bcb3821fcae9.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/ic_apple.png
// module id = 1022
// module chunks = 0